const TextArea = (props) => {
  return (
    <textarea {...props} />
  );
};

export default TextArea;
